import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';

function Container({ children, size }) {
  const containerClasses = classNames({
    [styles.container]: true,
    [styles[`container-${size}`]]: size,
  });

  return <div className={containerClasses}>{children}</div>;
}

Container.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
};

Container.defaultProps = {
  size: null,
};

export default Container;
